import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import moment from 'moment';
import { useEffect, useState } from 'react';
import DiscountConditionApiService from '../../services/discountCondition.api.service';
import useAlert from '../Alert/useAlert';
import { StyledBodyCell } from '../StyledBodyCell';
import { StyledHeaderCell } from '../StyledHeaderCell';

export const DiscountConditionTable = ({customer}) => {
    const {showErrorAlert} = useAlert();
    const [state, setState] = useState({
        conditions: [],
        loading: false,
    });

    useEffect(() => {onCustomerChange()}, [customer]);
    const changeState = (partialState) => setState(currentState => ({...currentState, ...partialState}));
    const startLoading = () => changeState({loading: true});
    const stopLoading = () => changeState({loading: false});

    const onCustomerChange = () => {
        if (!customer?.id) {
            changeState({conditions: []})
            return;
        }
        startLoading();
        DiscountConditionApiService
            .list(customer.id)
            .then(discountConditions => changeState({conditions: discountConditions.items}))
            .catch(err => showErrorAlert(err.response.data.message))
            .finally(() => stopLoading());
    };

    const formatDate = (date) => moment(date).format('DD/MM/YYYY');

    return <Table
        size="small"
        sx={{
            border: '1px solid grey',
            mb: 3,
        }}
    >
        <TableHead>
            <TableRow>
                <StyledHeaderCell>Name</StyledHeaderCell>
                <StyledHeaderCell>Country</StyledHeaderCell>
                <StyledHeaderCell>Category</StyledHeaderCell>
                <StyledHeaderCell>Patient type</StyledHeaderCell>
                <StyledHeaderCell>Discount</StyledHeaderCell>
                <StyledHeaderCell>Expiration date</StyledHeaderCell>
            </TableRow>
        </TableHead>
        <TableBody>
            {state.conditions.map(condition =>
                <TableRow key={condition.id}>
                    <StyledBodyCell>{condition.name}</StyledBodyCell>
                    <StyledBodyCell>{condition.country.name}</StyledBodyCell>
                    <StyledBodyCell>{condition.category.name}</StyledBodyCell>
                    <StyledBodyCell>{condition.patient_type.name}</StyledBodyCell>
                    <StyledBodyCell>{condition.amount}%</StyledBodyCell>
                    <StyledBodyCell>{formatDate(condition.expires)}</StyledBodyCell>
                </TableRow>
            )}
        </TableBody>
    </Table>
}
